import { render, staticRenderFns } from "./ModuleSetClient.vue?vue&type=template&id=32de4b27&scoped=true&lang=pug&"
import script from "./ModuleSetClient.vue?vue&type=script&lang=js&"
export * from "./ModuleSetClient.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSetClient.vue?vue&type=style&index=0&id=32de4b27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32de4b27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
